/******************************************************************************
 mlib-components
 Library for UI components widely used in LB apps.
 (c) Longboard Architectural Products
 ******************************************************************************/
var RunConfig = window['runConfig'];
var RunConfig$1 = RunConfig;

export { RunConfig$1 as default };
